import { escapeRegExp } from 'lodash';

export const replaceAll = (text: string, find: string, replaceWith: string) => {
  return text.replace(new RegExp(escapeRegExp(find), 'g'), replaceWith);
};
